import { createRouter, createWebHistory } from 'vue-router'
import UserPost from './views/UserPost.vue'
import VerificationPage from './components/VerificationPage.vue'
import ContractPage from './components/ContractPage.vue'
import UserProfile from './components/UserProfile.vue'
import BugReport from './components/BugReport.vue'
import { authGuard } from "@auth0/auth0-vue"
import HistoryPage from './components/HistoryPage.vue';
import RewardPage from './components/RewardPage.vue';
import NotificationPage from './components/NotificationPage.vue';
import SavedPage from './components/SavedPages.vue';
import settingsPage from './components/settingsPage.vue';
import UserSubmissions from './components/UserSubmissions.vue';
import TokenPopup from './components/TokenPopup.vue';
import TokenInfo from './components/TokenInfo.vue';
import IncentivesPage from './components/IncentivesPage.vue';
import DocumentInfoComponent from './components/DocumentInfoComponent.vue';
import PoolSort from './components/PoolSort.vue';
import frontPage from './components/frontPage.vue';
import LandingPage from './components/LandingPage.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [{ path: '/users/:username/posts/:postId', component: UserPost }, {
    path: '/verification-page',
    name: 'VerificationPage',
    component: VerificationPage
  },
  {
    path: '/contract-page',
    name: 'ContractPage',
    component: ContractPage,

  },
  {
    path: '/', // Default URL
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '/demo', // URL for frontPage.vue
    name: 'frontPage',
    component: frontPage,
  },

  { path: '/User-Profile', name: 'UserProfile', component: UserProfile, beforeEnter: authGuard, },

  { path: '/Incentives-Page', name: 'IncentivesPage', component: IncentivesPage, },

  { path: '/Bug-Report', name: 'bug-report', component: BugReport, },

  { path: '/History-Page', name: 'history-page', component: HistoryPage, },

  { path: '/demo', name: 'demo', component: frontPage, },

  { path: '/Pools-Page', name: 'pools-page', component: PoolSort, props:true },

  {
    path: '/Reward-Page', name: 'reward-page', component: RewardPage,
    children: [
      { path: 'month', component: RewardPage, },
      { path: 'recent', component: RewardPage, },
    ],
  },

  { path: '/Notification-Page', name: 'notification-page', component: NotificationPage, },

  {
    path: '/Saved-Page', name: 'saved-page', component: SavedPage, children: [
      { path: '', },
      { path: 'transactions', component: SavedPage, },
      { path: 'submissions', component: SavedPage, },
      { path: 'searches', component: SavedPage, },
    ],
  },


  { path: '/settings-Page', name: 'settings-page', component: settingsPage, },
  { path: '/User-Submissions', name: 'User-Submissions', component: UserSubmissions, },
  { path: '/:tokenValue', name: 'TokenPopup', component: TokenPopup, },
  { path: '/Token/:tokenName', component: TokenInfo, name: 'TokenInfo', props: true, children: [
    { path: '', },
    { path: 'about', component: TokenInfo, },
  ],
  

},

{
  path: '/document/:DocumentName',
  name: 'DocumentInfo',
  component: DocumentInfoComponent, // Replace with the actual component you want to render
  props: true // This allows the route parameters to be passed as props to the component
},

  
  {
    path: '/submission/:title',
    name: 'submissionDetail',
    component: TokenPopup,
    props: true,
  },

  ],
})
